import { Nav } from "@/components/Nav";
import { useEffect } from "react";
import { ExitIntent } from "@/components/ExitIntent";
import { trackVisit, initSectionTracking } from "@/lib/track";import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { OffersShowcase } from "@/components/OffersShowcase";
import { PackCalculator } from "@/components/PackCalculator";
import { Soho } from "@/components/Soho";
import { EnecoTeaser } from "@/components/EnecoTeaser";
import { Referral } from "@/components/Referral";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";
import { SeoText } from "@/components/SeoText";
import { ChatWidget } from "@/components/ChatWidget";

export default function Home() {
  useEffect(() => {
    trackVisit();
    return initSectionTracking();
  }, []);

  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Services />
      <OffersShowcase />
      <PackCalculator />
      <Referral />
      <Soho />
      <EnecoTeaser />
      <Manifesto />
      <About />
      <Testimonials />
      <FAQ />
      <SeoText />
      <LeadForm />
      <Footer />
      <ChatWidget />
      <ExitIntent />
    </main>
  );
}
